import React from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as icons_solid from "@fortawesome/free-solid-svg-icons";

export const stringOrJSON = value => {
	let v = value;
	try {
		v = JSON.parse(value);
	} catch (e) {}
	return v;
};

/**
 * Internal get value from cookie
 * @param {string} key Cookie key
 */
export const getCookie = key => {
	const cookieObject = {};
	const original = window.document.cookie;
	const cookieStrings = decodeURIComponent(original).split(';');
	for (let i = 0; i < cookieStrings.length; i++) {
		if (cookieStrings[i].trim().indexOf(`${key}=`) === 0) {
			const [a, b] = cookieStrings[i].trim().split('=');
			cookieObject[a] = b;
			break;
		}
	}
	return (key in cookieObject) ? cookieObject[key] : null;
};

/**
 * Set value to cookie
 * @param {string} key Cookie key
 * @param {string} value Cookie value
 * @param {number} expiry Minutes before cookie will expire
 */
export const setCookie = (key, value, expiry) => {
	const now = new Date();
	const time = now.getTime();
	const expiryMS = expiry * 60 * 1000;
	now.setTime(expiryMS + time);
	const nowUTC = now.toUTCString();
	const cookie = `${key}=${value}; Expires=${nowUTC}; Path=/`;
	window.document.cookie = cookie;
};

/**
 * Remove cookie
 * @param {string} key Cookie key
 */
export const removeCookie = key => {
	setCookie(key, '', -20160);
};

export const downIcon = (<span style={{float: 'right', position: 'relative', right: '4px', top: '-3px'}}><FontAwesomeIcon className="text-dark" icon={icons_solid.faSortDown} size="lg" /></span>);
export const upIcon = (<span style={{float: 'right', position: 'relative', right: '4px', top: '3px'}}><FontAwesomeIcon className="text-dark" icon={icons_solid.faSortUp} size="lg" /></span>);

export const dash = <>&ndash;</>;

export const SpinnerLineDark = () => (
	<div className="position-absolute w-100 h-100" style={{backgroundColor:'#ddd',left:0,opacity:0.5,top:0,zIndex:1}}>
		<div className="spinner-border spinner-border-sm position-absolute" style={{left:'calc(50% - 8px)',top:'calc(50% - 8px)'}} />
	</div>
);

export const outcome_color = outcome => ({
	'Abandoned Call': 'bg-danger',
	'Booked Appointment': 'bg-success',
	'Cannot Leave Voicemail': 'bg-danger',
	'Disconnected': 'bg-danger',
	'Do Not Call': 'bg-danger',
	'Error': 'bg-danger',
	'Left Voicemail': 'bg-info',
	'Non Mobile': 'bg-info',
	'Needs Callback': 'bg-success',
	'No Text Reply': 'bg-secondary',
	'Outside of US': 'bg-info',
	'Scheduled Callback': 'bg-success',
	'Scheduled Immediate Callback': 'bg-success',
	'Text Replied': 'bg-dark'
}[outcome] || 'bg-secondary');

// Base64 → Uint8Array
export const base64ToUint8Array = base64 => {
	const binary = atob(base64);
	const len = binary.length;
	const bytes = new Uint8Array(len);
	for (let i = 0; i < len; i++) bytes[i] = binary.charCodeAt(i);
	return bytes;
};

// Gzip decompress using native API
export const gunzipBase64 = async base64 => {
	const compressed = base64ToUint8Array(base64);
	const stream = new Blob([compressed])
		.stream()
		.pipeThrough(new DecompressionStream('gzip'));
	const decompressed = await new Response(stream).arrayBuffer();
	return new TextDecoder().decode(decompressed);
};

export const build_logs_insights_url = ({
	log_groups = [],
	query,
	region = 'us-east-1',
	relative_seconds = 518400,
	tz = 'UTC',
}) => {
	const cwEncode = (s) =>
  		encodeURIComponent(String(s))
	    	.replace(/%/g, '*')
    		.replace(/\(/g, '*28')
    		.replace(/\)/g, '*29')
    		.toLowerCase();

	const editorString = cwEncode(query);

	const sourcePart =
		log_groups.length > 0
			? `~source~(~${log_groups.map(lg => `'${cwEncode(lg)}`).join('~')})`
			: '';

	const queryDetail =
		`~(` +
		`end~0~start~-${relative_seconds}~timeType~'RELATIVE~tz~'${tz}~unit~'seconds` +
		`~editorString~'${editorString}` +
		sourcePart +
		`~lang~'CWLI~logClass~'STANDARD~queryBy~'logGroupName` +
		`)`;
	return (
	    `https://${region}.console.aws.amazon.com/cloudwatch/home` +
	    `?region=${region}` +
	    `#logsV2:logs-insights$3FqueryDetail$3D` +
	    queryDetail
  	);
};
